import { CalendarMonth, ChevronRight, Download, LocationOn, People, WatchLater, ExpandMore, ExpandLess, QuestionMarkRounded, Launch, DownloadOutlined, MailOutlined, Mail } from "@mui/icons-material";
import { ReactComponent as CheckIcon } from '../Images/Time.svg';
import { ReactComponent as DOCIcon } from '../Images/file_icons/DOC.svg';
import { ReactComponent as DOCXIcon } from '../Images/file_icons/DOCX.svg';
import { ReactComponent as PDFIcon } from '../Images/file_icons/PDF.svg';
import { ReactComponent as PPTIcon } from '../Images/file_icons/PPT.svg';
import { ReactComponent as PDF2Icon } from '../Images/public/PDF.svg';
import { ReactComponent as XSLIcon } from '../Images/file_icons/XSL.svg';

import { ReactComponent as ZIPIcon } from '../Images/file_icons/ZIP.svg';



export const ICONS = {
    download: () => <Download></Download>,
    downloadoutline: () => <DownloadOutlined></DownloadOutlined>,
    mail: () => <Mail/>,
    mailoutlined: () => <MailOutlined></MailOutlined>,
    location: () => <LocationOn/>,
    people: () => <People/>,
    time: () => <WatchLater/>,
    calendar: () => <CalendarMonth/>,
    upArrow: () => <ExpandLess/>,
    downArrow: () => <ExpandMore/>,
    rightArrow: () => <ChevronRight/>,
    questionMark: () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M7.71387 0C9.11343 0 10.405 0.344444 11.5869 1.03418C12.7686 1.72381 13.7039 2.66168 14.3936 3.84668C15.0832 5.02514 15.4286 6.31447 15.4287 7.71387C15.4287 9.11343 15.0833 10.405 14.3936 11.5869C13.7039 12.7684 12.7684 13.7039 11.5869 14.3936C10.405 15.0833 9.11343 15.4287 7.71387 15.4287C6.31447 15.4286 5.0236 15.0832 3.8418 14.3936C2.6601 13.7039 1.72383 12.7686 1.03418 11.5869C0.344444 10.405 0 9.11343 0 7.71387C6.87682e-05 6.31447 0.344513 5.0236 1.03418 3.8418C1.72391 2.65989 2.65989 1.72391 3.8418 1.03418C5.0236 0.344513 6.31447 6.87684e-05 7.71387 0ZM6.75 10.2861C6.65625 10.2861 6.57882 10.3157 6.51855 10.376C6.45838 10.4362 6.42871 10.5137 6.42871 10.6074V12.5361C6.4288 12.6295 6.45856 12.7065 6.51855 12.7666C6.57882 12.8269 6.65625 12.8574 6.75 12.8574H8.67871C8.77233 12.8574 8.84896 12.8267 8.90918 12.7666C8.96936 12.7064 8.99991 12.6297 9 12.5361V10.6074C9 10.5137 8.96945 10.4362 8.90918 10.376C8.84898 10.3159 8.77225 10.2862 8.67871 10.2861H6.75ZM7.91504 2.57129C6.28787 2.57133 5.0456 3.28463 4.18848 4.71094C4.08813 4.87154 4.11479 5.01234 4.26855 5.13281L5.59473 6.1377C5.64159 6.1778 5.70585 6.19727 5.78613 6.19727C5.89308 6.19716 5.97692 6.1574 6.03711 6.07715C6.3918 5.62208 6.67947 5.31411 6.90039 5.15332C7.12807 4.99261 7.41643 4.91211 7.76465 4.91211C8.08591 4.91213 8.37203 4.99889 8.62305 5.17285C8.87416 5.34696 9 5.54464 9 5.76562C9 6.02004 8.9327 6.22392 8.79883 6.37793C8.66493 6.53191 8.43752 6.68279 8.11621 6.83008C7.69436 7.01757 7.3076 7.30751 6.95605 7.69922C6.60449 8.09096 6.42871 8.5113 6.42871 8.95996V9.32129C6.42871 9.415 6.45833 9.49248 6.51855 9.55273C6.57882 9.613 6.65625 9.64258 6.75 9.64258H8.67871C8.77222 9.64255 8.84899 9.61274 8.90918 9.55273C8.96945 9.49247 9 9.41504 9 9.32129C9.00005 9.19409 9.07193 9.02836 9.21582 8.82422C9.35979 8.61998 9.54269 8.45438 9.76367 8.32715C9.97788 8.20665 10.142 8.11131 10.2559 8.04102C10.3697 7.9707 10.5236 7.85345 10.7178 7.68945C10.912 7.52539 11.0612 7.3644 11.165 7.20703C11.2688 7.04972 11.3626 6.84722 11.4463 6.59961C11.53 6.35196 11.5712 6.08062 11.5713 5.78613C11.5713 5.19684 11.3853 4.65067 11.0137 4.14844C10.6421 3.64635 10.1787 3.25792 9.62305 2.9834C9.06724 2.70884 8.49763 2.57129 7.91504 2.57129Z" fill="#193F64"/>
                        </svg>,
    arrow: () => <svg xmlns="http://www.w3.org/2000/svg" width="40" height="28" viewBox="0 0 40 28" fill="none">
                    <path d="M2.22151 12.3126C1.77948 12.3126 1.35556 12.4904 1.043 12.8069C0.730434 13.1233 0.55484 13.5526 0.55484 14.0001C0.55484 14.4477 0.730434 14.8769 1.043 15.1934C1.35556 15.5098 1.77948 15.6876 2.22151 15.6876V12.3126ZM38.9548 15.1926C39.267 14.8762 39.4423 14.4473 39.4423 14.0001C39.4423 13.5529 39.267 13.124 38.9548 12.8076L28.3482 2.06836C28.1956 1.90256 28.0116 1.76958 27.8071 1.67735C27.6027 1.58512 27.382 1.53553 27.1582 1.53153C26.9344 1.52753 26.7122 1.56921 26.5046 1.65408C26.2971 1.73896 26.1086 1.86528 25.9503 2.02552C25.792 2.18576 25.6673 2.37664 25.5835 2.58677C25.4996 2.79689 25.4585 3.02195 25.4624 3.24854C25.4664 3.47512 25.5153 3.69857 25.6064 3.90557C25.6975 4.11257 25.8289 4.29887 25.9926 4.45336L35.4193 14.0001L25.9926 23.5469C25.6982 23.8668 25.5379 24.2899 25.5456 24.727C25.5532 25.1642 25.7281 25.5813 26.0335 25.8905C26.3388 26.1997 26.7508 26.3768 27.1826 26.3845C27.6143 26.3922 28.0322 26.2299 28.3482 25.9319L38.9548 15.1926ZM2.22151 15.6876H37.7771V12.3126H2.22151V15.6876Z" fill="#0C6DB0"/>
                </svg>,
    check: () => <CheckIcon/>,
    launch: () => <Launch/>,
    communitypharmacy: ()=> <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.25" width="64" height="64" rx="32" fill="#84BDF3"/>
<path d="M50.5 20.25H45.22L47.5 13.97L42.8 12.25L39.88 20.25H14.5V24.25L18.5 36.25L14.5 48.25V52.25H50.5V48.25L46.5 36.25L50.5 24.25V20.25ZM40.5 38.25H34.5V44.25H30.5V38.25H24.5V34.25H30.5V28.25H34.5V34.25H40.5V38.25Z" fill="white"/>
</svg>,
    nursinghome: () => <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="64" height="64" rx="32" fill="#84BDF3"/>
<path d="M33.5 19C35.7 19 37.5 17.2 37.5 15C37.5 12.8 35.7 11 33.5 11C31.3 11 29.5 12.8 29.5 15C29.5 17.2 31.3 19 33.5 19ZM46.5 33V54H44.5V33C44.5 32.44 44.06 32 43.5 32C42.94 32 42.5 32.44 42.5 33V35H40.5V33.62C37.58 32.86 35.1 31.04 33.48 28.58C32.86 30.32 32.5 32.14 32.5 34C32.5 34.46 32.54 34.92 32.56 35.38L36.5 41V54H32.5V44L28.94 38.92L28.5 46L22.5 54L19.3 51.6L24.5 44.66V34C24.5 31.7 24.86 29.42 25.5 27.22L22.5 28.92V36H18.5V26.6L29.3 20.46V20.48C30.48 19.86 31.94 19.82 33.18 20.54C33.9 20.96 34.44 21.56 34.78 22.24L36.36 25.58C37.66 28.2 40.38 30 43.5 30C45.16 30 46.5 31.34 46.5 33Z" fill="white"/>
</svg>,
    ds: () => 
        <svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" width="64" height="64" rx="32" fill="#84BDF3"/>
<path d="M35 52C31.4 52 28.3333 50.7333 25.8 48.2C23.2667 45.6667 22 42.6 22 39V37.85C19.1333 37.3833 16.75 36.0413 14.85 33.824C12.95 31.6067 12 28.9987 12 26V14H18V12H22V20H18V18H16V26C16 28.2 16.7833 30.0833 18.35 31.65C19.9167 33.2167 21.8 34 24 34C26.2 34 28.0833 33.2167 29.65 31.65C31.2167 30.0833 32 28.2 32 26V18H30V20H26V12H30V14H36V26C36 29 35.05 31.6087 33.15 33.826C31.25 36.0433 28.8667 37.3847 26 37.85V39C26 41.5 26.8753 43.6253 28.626 45.376C30.3767 47.1267 32.5013 48.0013 35 48C37.4987 47.9987 39.624 47.124 41.376 45.376C43.128 43.628 44.0027 41.5027 44 39V35.65C42.8333 35.25 41.8753 34.5333 41.126 33.5C40.3767 32.4667 40.0013 31.3 40 30C40 28.3333 40.5833 26.9167 41.75 25.75C42.9167 24.5833 44.3333 24 46 24C47.6667 24 49.0833 24.5833 50.25 25.75C51.4167 26.9167 52 28.3333 52 30C52 31.3 51.6253 32.4667 50.876 33.5C50.1267 34.5333 49.168 35.25 48 35.65V39C48 42.6 46.7333 45.6667 44.2 48.2C41.6667 50.7333 38.6 52 35 52Z" fill="white"/>
</svg>

    ,
    hs: () => 
        <svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" width="64" height="64" rx="32" fill="#84BDF3"/>
<path d="M46.5 14H18.5C16.3 14 14.52 15.8 14.52 18L14.5 46C14.5 48.2 16.3 50 18.5 50H46.5C48.7 50 50.5 48.2 50.5 46V18C50.5 15.8 48.7 14 46.5 14ZM44.5 36H36.5V44H28.5V36H20.5V28H28.5V20H36.5V28H44.5V36Z" fill="white"/>
</svg>

    ,
    sh: () => 
        <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="64" height="64" rx="32" fill="#84BDF3"/>
<path d="M50.0799 26.96L46.0799 20.04L36.4999 25.58V14.5H28.4999V25.58L18.9199 20.04L14.9199 26.96L24.4999 32.5L14.9199 38.04L18.9199 44.96L28.4999 39.42V50.5H36.4999V39.42L46.0799 44.96L50.0799 38.04L40.4999 32.5L50.0799 26.96Z" fill="white"/>
</svg>,

pdf: () => <PDF2Icon></PDF2Icon>

};

export const getFileTypeIcon = (fileExt) => {
    //File Ext: "doc", "docx", "pdf", "ppt", "pptx", "xls", "xlsx", "zip"
    
        // if (equalsIgnoreCase("doc",fileExt) || equalsIgnoreCase("docx",fileExt) ) {

        //     fileImage = WordIcon;//"icon-word.png";
        //     imageAlt = "word document";
        // } 
        // else if (equalsIgnoreCase("ppt",fileExt) || equalsIgnoreCase("pptx",fileExt)) {    

        //     fileImage = "icon-powerPoint.png";
        //     imageAlt = "power point document";
        // } 
        // else if (equalsIgnoreCase("pdf",fileExt)) {    

        //     fileImage = PDFIcon;//"icon-pdf.png";
        //     imageAlt = "PDF document";
        // } 
        // else if (equalsIgnoreCase("xlsx",fileExt)  || equalsIgnoreCase("xls",fileExt) ) {    

        //     fileImage = "icon-excel.png";
        //     imageAlt = "excel document";
        // } 
        // else if (equalsIgnoreCase("zip",fileExt)) {    

        //     fileImage = "zip.png";
        //     imageAlt = "zip file";
        // }
        
    var lower = fileExt.toLowerCase();
    var typeMapping = {
        doc: () => <DOCIcon/>,
        docx: () => <DOCXIcon/>,
        pdf: () => <PDFIcon/>,
        ppt: () => <PPTIcon/>,
        pptx: () => <PPTIcon/>,
        xls: () => <XSLIcon/>,
        xlsx: () => <XSLIcon/>,
        zip: () => <ZIPIcon/>
    }

    return typeMapping[lower];
}

export const getFileTypeColor = (fileExt) => {
    //File Ext: "doc", "docx", "pdf", "ppt", "pptx", "xls", "xlsx", "zip"
    const red = "red-ext";
    const purple = "purple-ext";
    const green = "green-ext";
    const blue = "blue-ext";
    const orange = "orange-ext";
    var typeMapping = {
        doc: blue,
        docx: blue,
        pdf: red,
        ppt: orange,
        pptx: orange,
        xls: green,
        xlsx: green,
        zip: purple
    }
    if(fileExt!=null){
        var lower = fileExt.toLowerCase();
        if(typeMapping.hasOwnProperty(lower)){
            return typeMapping[lower];
        }
    }
    return "";
}